export const PAGE_SIZE = 20

export const HTTP_TYPE_GET = 'GET'
export const HTTP_TYPE_POST = 'POST'

export const CONTENT_TYPE_FORM = 'form'
export const CONTENT_TYPE_FILE = 'file'

export const USER = {
  AUTH: {
    ADMIN: 99
  }
}

export const MODULE_TYPE = {
  WECHAT: 1,
  PLATFORM: 2
}

export const CUSTOMER_BASIC_TYPE = {
  DEALER: 1,
  FARM: 2
}

export const TOGGLE_MENU_FROM_WHERE = {
  MENU: 0,
  TAB: 1
}
